/* eslint-disable react/no-danger */
import type { TNotify } from 'src/@types/notification';

import Box from '@mui/material/Box';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { fToNow } from 'src/utils/format-time';

import { ButtonContained, ButtonOutline } from 'src/components';
import { CONFIG } from 'src/config-global';

import { FileThumbnail } from 'src/components/file-thumbnail';

export function NotificationItem({ notification }: { notification: TNotify }) {
  const renderAvatar = (
    <ListItemAvatar>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: 'background.neutral' }}
      >
        <Box
          component="img"
          src={`${CONFIG.site.basePath}/assets/icons/lms-icon/icon-${notification.type === 'GRADE' ? 'notification' : notification.type}.svg`}
          sx={{ width: 24, height: 24 }}
        />
      </Stack>
    </ListItemAvatar>
  );

  const renderText = (
    <ListItemText
      disableTypography
      primary={reader(notification.title)}
      secondary={
        <Stack
          direction="column"
          alignItems="flex-start"
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          <Typography
            variant="caption"
            color="text"
            sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}
          >
            <p dangerouslySetInnerHTML={{ __html: notification.bodyNotification }} />
          </Typography>
          <Typography variant="caption" color="text.disabled">
            {fToNow(notification.createdAt)}
          </Typography>
        </Stack>
      }
    />
  );

  const renderUnReadBadge = !notification.isRead && (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'info.main',
        position: 'absolute',
      }}
    />
  );

  const fileAction = (
    <Stack
      spacing={1}
      direction="row"
      sx={{
        pl: 1,
        p: 1.5,
        mt: 1.5,
        borderRadius: 1.5,
        bgcolor: 'background.neutral',
      }}
    >
      <FileThumbnail file="" />

      <Stack spacing={1} direction={{ xs: 'column' }} flexGrow={1} sx={{ minWidth: 0 }}>
        <ListItemText
          disableTypography
          primary={
            <Typography variant="subtitle2" component="div" sx={{ color: 'text.secondary' }} noWrap>
              design-suriname-2015.mp3
            </Typography>
          }
          secondary={
            <Stack
              direction="row"
              alignItems="center"
              sx={{ typography: 'caption', color: 'text.disabled' }}
              divider={
                <Box
                  sx={{
                    mx: 0.5,
                    width: 2,
                    height: 2,
                    borderRadius: '50%',
                    bgcolor: 'currentColor',
                  }}
                />
              }
            >
              <span>2.3 GB</span>
              <span>30 min ago</span>
            </Stack>
          }
        />
        <Stack
          spacing={1}
          direction={{ xs: 'column', sm: 'row' }}
          flexGrow={1}
          sx={{ minWidth: 0 }}
        >
          <ButtonOutline
            sx={{
              typography: 'caption',
            }}
            size="small"
          >
            Đọc ngay
          </ButtonOutline>
          <ButtonContained
            sx={{
              typography: 'caption',
            }}
            size="small"
          >
            Tải xuống
          </ButtonContained>
        </Stack>
      </Stack>
    </Stack>
  );
  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.vars.palette.divider}`,
      }}
    >
      {renderUnReadBadge}

      {renderAvatar}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}

        {notification.attachments && fileAction}
      </Stack>
    </ListItemButton>
  );
}

function reader(data: string) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        mb: 0.5,
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}
